import React, { Component } from 'react';
import PropTypes from 'prop-types';

import LoadingPage from '../LoadingPage';
import { completeAuth } from '../../common/auth';

class AuthFinish extends Component {
  componentDidMount() {
    const { history } = this.props;
    completeAuth()
      .then((result) => {
        if (result) {
          history.replace(result.entryPath);
        }
      })
      .catch((e) => {
        console.error(e);
        history.replace('/');
      });
  }

  render() {
    return <LoadingPage size="xxl" />;
  }
}

AuthFinish.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
};

export default AuthFinish;
